import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function NotFinished() {
  const navigate = useNavigate();
  const [isImageExpanded, setIsImageExpanded] = useState(false);

  const savedTheme = localStorage.getItem('theme');
  if (savedTheme) {
    const isDarkMode = document.documentElement.classList.contains('dark-mode');
    if (savedTheme === 'dark' && !isDarkMode) {
      document.documentElement.classList.add('dark-mode');
    } else if (savedTheme === 'light' && isDarkMode) {
      document.documentElement.classList.remove('dark-mode');
    }
  }

  const toggleImage = () => {
    setIsImageExpanded(!isImageExpanded);
  };

  const toggleTheme = () => {
    const isDarkMode = document.documentElement.classList.toggle('dark-mode');
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  };

  return (
    <div className="App">
      <nav className="main-nav">
        <div className="nav-left">
          <div className="headshot-container">
            <img 
              src="/static/images/home/profile-picture.png" 
              alt="Profile" 
              className="headshot" 
              onClick={() => navigate('/')}
            />
          </div>
          <div className="nav-logo">Robert Study</div>
        </div>
        <div className="nav-links">
          <a onClick={() => navigate('/')}>Back to Home</a>
        </div>
      </nav>

      <section className="hero-section">
        <div className="hero-content" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
        }}>
          <img 
            src="/static/images/under-construction.png" 
            alt="Under Construction" 
            style={{ width: '180px', marginBottom: '2rem' }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>This Page Isn't Finished Yet!</h1>
          <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
            I'm still working on this project page.<br />
            Check back soon, or explore the rest of the site!
          </p>
          <button className="cta-button" onClick={() => navigate('/')}>Go Home</button>
        </div>
      </section>

      <footer style={{
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-color)',
        padding: '1.5rem',
        textAlign: 'center',
        borderTop: '1px solid var(--accent-color)',
        marginTop: '2rem'
      }}>
        <p style={{ 
          fontSize: '0.9rem',
          opacity: '0.8'
        }}>
          © {new Date().getFullYear()} Robert Study. All rights reserved.
        </p>
      </footer>

      <button onClick={toggleTheme} className="theme-toggle">
        <span className="light-icon">Light Mode</span>
        <span className="dark-icon">Dark Mode</span>
      </button>

      {isImageExpanded && (
        <div className="modal-overlay" onClick={toggleImage}>
          <div className="modal-content">
            <img 
              src="/static/images/profile-picture.png"
              alt="Profile" 
              className="expanded-profile-pic"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default NotFinished; 